module.exports = __webpack_public_path__ + "img/back_to_school.65a6a663.svg";